import * as React from 'react';
import { memo, SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1047_3756)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C18.6279 0 24 5.37212 24 12C24 18.6279 18.6279 24 12 24C5.37212 24 0 18.6279 0 12C0 5.37212 5.37212 0 12 0Z"
        fill="#24DD9A"
      />
      <path d="M7 16H13V18H7V16Z" fill="white" />
      <path
        d="M13 16H9V6H14.0863C14.8462 6 15.53 6.08737 16.1379 6.26212C16.7458 6.4314 17.2608 6.67986 17.6829 7.00751C18.1107 7.32969 18.4371 7.7256 18.6623 8.19522C18.8874 8.66485 19 9.19454 19 9.7843C19 10.4287 18.8762 11.0075 18.6285 11.5208C18.3809 12.0341 18.0488 12.471 17.6323 12.8314C17.2214 13.1863 16.7458 13.4594 16.2054 13.6505C15.6651 13.8416 15.0994 13.9372 14.5084 13.9372C14.4296 13.9372 14.348 13.9372 14.2636 13.9372C14.1792 13.9317 14.0835 13.9208 13.9765 13.9044V12.258C14.0385 12.2689 14.2383 12.4246 14.3058 12.43C14.3734 12.43 14.4381 12.43 14.5 12.43C14.8096 12.43 15.0882 12.3727 15.3358 12.258C15.5835 12.1433 15.7917 11.985 15.9606 11.7829C16.1351 11.5754 16.2674 11.327 16.3574 11.0375C16.4531 10.7481 16.5009 10.4259 16.5009 10.071C16.5009 9.63413 16.439 9.26007 16.3152 8.94881C16.1914 8.63754 16.0141 8.38362 15.7833 8.18703C15.5582 7.99044 15.2795 7.84573 14.9475 7.7529C14.621 7.66007 14.2552 7.61365 13.8499 7.61365H13V16Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1047_3756">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgComponent);
export default Memo;
